module.exports = __webpack_public_path__ + "static/media/icon.65e5c911.png";